import { Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { ClarifyChallengeComponent } from './../clarify-challenge/clarify-challenge.component';
import { IdeateChallengeComponent } from '../ideate-challenge/ideate-challenge.component';
import { CnEditmodeService } from '../challenges_service/cn-editmode.service';
import { SlideoutContentService } from '../../../service/slideout-content.service';
import { Router } from '@angular/router';
import { DevelopChallengeComponent } from '../develop-challenge/develop-challenge.component';
import { ImplementChallengeComponent } from '../implement-challenge/implement-challenge.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-tooltip-popup',
  templateUrl: './tooltip-popup.component.html',
  styleUrls: ['./tooltip-popup.component.scss']
})
export class TooltipPopupComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  process_type: string;
  popup_type: string;
  showVideo: boolean = false;
  DivergeConvergeVal: boolean = false;
  hideOnEditMode: boolean = true;
  all_data: any = [];
  slideoutChallenge: any;
  slideoutIdeas: any;
  slideoutTopIdeas: any;
  slideoutDivergeContent: any;
  slideoutConvergeContent: any;
  injectedCompo: any;
  slideoutSolution: any;
  slideoutAction: any;
  slideoutInNext24: any;
  slideoutIssues: any;
  slideoutOpportunities: any;
  slideoutPluses: any;
  slideoutSolutionPrototype: any;
  slideoutStrengthen: any;
  slideoutthink: any;

  constructor(
    public injector: Injector,
    public editmodeService: CnEditmodeService,
    public slideContent: SlideoutContentService,
    public route: Router
  ) {}

  ngOnInit() {
    if (this.route.url.includes('ideate')) {
      this.injectedCompo = this.injector.get(IdeateChallengeComponent);
    } else if (this.route.url.includes('develop')) {
      this.injectedCompo = this.injector.get(DevelopChallengeComponent);
    } else if (this.route.url.includes('implement')) {
      this.injectedCompo = this.injector.get(ImplementChallengeComponent);
    } else {
      this.injectedCompo = this.injector.get(ClarifyChallengeComponent);
    }

    const content = this.slideContent.divergeConvergeContent();
    this.slideoutDivergeContent = content.ideate.diverge;
    this.slideoutConvergeContent = content.ideate.converge;
    this.slideoutChallenge = content.ideate.challenge;
    this.slideoutIdeas = content.ideate.ideas;
    this.slideoutTopIdeas = content.ideate.topIdea;
    this.slideoutSolution = content.implement.solution;
    this.slideoutAction = content.implement.action;
    this.slideoutInNext24 = content.implement.inNext24;
    this.slideoutIssues = content.develop.issues;
    this.slideoutOpportunities = content.develop.opportunities;
    this.slideoutPluses = content.develop.pluses;
    this.slideoutSolutionPrototype = content.develop.solutionPrototype;
    this.slideoutStrengthen = content.develop.strengthen;
    this.slideoutthink = content.develop.newthink;

    this.editmodeService.tooltipPopup.pipe(
      takeUntil(this.destroy$)
    ).subscribe((val) => {
      this.process_type = val.process_type;
      this.popup_type = val.popup_type;
      this.showVideo = val.showVideo;
      this.DivergeConvergeVal = val.DivergeConvergeVal;
      this.hideOnEditMode = val.hideOnEditMode;
      this.getFrameWorkData();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public getFrameWorkData() {
    const raw = localStorage.getItem('CN_FRAMEWORKS');
    if (!raw) {
      this.all_data = [];
      return;
    }
    let allData: any = JSON.parse(raw);
    allData?.forEach((el: any) => {
      if (el.content && typeof el.content === "string") {
        try {
          el.content = JSON.parse(el.content);
        } catch (e) {
          // keep original value if not valid JSON
        }
      }
    });
    this.all_data = allData;
  }

  public getStageByTitle(data: any, title: any, subTitle: any = null) {
    if (!data || !Array.isArray(data)) return null;
    const item = data.find((item: any) => item.title === title);
    if (!item?.content) return null;

    try {
      if (title == 'point') {
        if (subTitle == 'new_thinking') {
          return JSON.parse(JSON.parse(item.content?.point[subTitle])[1]) || null;
        }
        if (subTitle) {
          return JSON.parse(item.content?.point[subTitle]) || null;
        }
      } else if (title == 'action-plan') {
        if (subTitle) {
          return JSON.parse(item.content?.[subTitle]) || null;
        }
      }
      return item.content || null;
    } catch (e) {
      return null;
    }
  }

  public closePopup() {
    this.editmodeService.tooltipPopup.next({
      process_type: '',
      popup_type: '',
      showVideo: false,
      DivergeConvergeVal: false,
      hideOnEditMode: true
    });
  }

  public sliderVideo() {
    this.showVideo = !this.showVideo;
  }

  public popupDetail(content: any) {
    this.popup_type = content;
  }

  public checkPopupForRole() {
    if (this.route.url.includes('ideate')) {
      return 'ideate';
    } else if (this.route.url.includes('develop')) {
      return 'develop';
    } else if (this.route.url.includes('implement')) {
      return 'implement';
    }
    return 'clarify';
  }
}
